import React from 'react';
import ReactDOM from 'react-dom';
import MainCategories from './MainCategories';
import SubcategoriesProducts from './pages/SubcategoriesProducts';

function Content({categories, addToCart}) {
    return (
        <div className="fullwidth-template">

            
            <MainCategories
                categories={categories}
            />

            
        </div>
    );
}

export default Content;